import React from 'react'
import { FinderContextProvider } from './src/helpers/finderContext'

export const wrapRootElement = ({ element }) => (
  <FinderContextProvider>{element}</FinderContextProvider>
)
